import { EServerAccountStatus, EServerBenefit, EAuthStatus, EAuthType, EBusinessTags, EProxyPayType, EProductProxyType, EServerType } from '../common';

export interface IServerAccountParam {
  /** 服务商id */
  id?: number;
  /** 服务商编号 */
  code?: number;
  /** 服务商活状态 */
  enable?: EServerAccountStatus;
  /** 实名状态 */
  authStatus?: EAuthStatus;
  /** 是否强制实名 */
  isAuth?: EAuthType;
  /** 受益人信息(0未配置 1已配置)	 */
  uboInfo?: number;
  /** 当前页码（从1开始） */
  page?: number;
  /** 每页显示条数 */
  size?: number;
  /** 创建时间开始 */
  createTimeStart?: string;
  /** 创建时间结束 */
  createTimeEnd?: string;
  /** 业务标签 */
  businessId?: EBusinessTags;
  /** 服务商类型 */
  serverType?: EServerType;
}

export interface IServerAccount {
  /** 服务商id */
  id?: number;
  /** 服务商编号 */
  code?: number;
  /** 服务商名称 */
  serverName?: string;
  /** 受益人信息配置 */
  uboInfo?: EServerBenefit;
  /** 受益人信息*/
  uboInfoStr?: string;
  /** 服务商活状态 */
  enable?: EServerAccountStatus;
  /** 是否开启*/
  enableStr?: string;
  /** 是否强制实名 */
  isAuth?: EAuthType;
  /** 强制实名*/
  isAuthStr?: string;
  /** 实名状态 */
  authStatus?: EAuthStatus;
  /** 实名状态*/
  authStatusStr?: string;
  /** 管理员名称 */
  name?: string;
  /** 管理员手机号 */
  phone?: string;
  /** 费率状态 */
  rateConfigStatus?: ERateStatus;
  /** 业务标签ID */
  businessIds?: EBusinessTags[];
  /** 业务标签名称 */
  businessNames?: string;
  /** 产品配置 */
  productProxyType?: number[];
  /** 收入性质 */
  proxyPayType?: EProxyPayType[];
  /** 服务商类型 */
  serverType?: EServerType;
}

export interface IUpdateServerPasswordParam {
  /** 服务商ID */
  id?: number;
  /** 验证码 */
  code?: string;
  /** 新密码 */
  newPassword?: string;
  /** 确认密码 */
  newPasswordConfirm: string;
}

export interface IUpdateServerPhoneParam {
  /** 服务商ID */
  id: number;
  /** 旧手机号码 */
  oldPhone: string;
  /** 旧手机验证码 */
  code: string;
  /** 新手机号码 */
  newPhone: string;
  /** 新手机验证码 */
  newCode: string;
}

export enum ERateStatus {
  /** 未配置 */
  NOT_CONFIGURED = 0,
  /** 已配置 */
  CONFIGURED = 1,
}

export const rateStatusConfig = {
  [ERateStatus.NOT_CONFIGURED]: '未配置',
  [ERateStatus.CONFIGURED]: '已配置',
};

export const rateStatusStyle = {
  [ERateStatus.NOT_CONFIGURED]: 'info',
  [ERateStatus.CONFIGURED]: 'success',
};

export interface IServerRateConfigParams {
  /** 服务商ID */
  serverId: number;
  /** 个税费率配置 */
  rateList: IRate[];
  /** 增值税费率 */
  addedRate: number|string;
  /** 城市建设税率 */
  cityConstructionRate: number|string;
  /** 城市建设税率减征率 */
  cityConstructionRateReduce: number|string;
  /** 教育费附加税费 */
  eduRate: number|string;
  /** 教育费附加税费减征率 */
  eduRateReduce: number|string;
  /** 地方教育费附加税费 */
  localEduRate: number|string;
  /** 地方教育费附加税费减征率 */
  localEduRateReduce: number|string;
  /** 技术服务印花税 */
  techServiceRate: number|string;
  /** 技术服务印花税减征率 */
  techServiceRateReduce: number|string;
  /**  */
  type?: number;
  /** 收入性质 */
  proxyPayType?: EProxyPayType;
}

export interface IServerRateDeatil extends IServerRateConfigParams {
  /** 个税征收模板ID */
  id: number;
}

export interface IRateBase {
  /** 费率 */
  scale: number;
}
export interface IRate {
  /** 金额下限 */
  minAmount?: number;
  /** 金额上限 */
  maxAmount: number|string;
  /** 个税费率 */
  personalRate: number|string;
  rate?: number;
}

export interface IServerBusinessLine {
  /** 业务线ID */
  id: number;
  /** 业务线名称 */
  name: string;
  /** 业务线类型 */
  type: 0 | 1;
}

export interface IServerProductTypeItem {
  /** 是否选中 */
  checked?: 0 | 1;
  /** 是否配置 */
  config?: boolean;
  /** key */
  key?: EProductProxyType;
}
